import Vue from 'vue'
import Popover from 'vux/src/components/popover/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import Masker from 'vux/src/components/masker/index.vue'
import Previewer from 'vux/src/components/previewer/index.vue'
import XProgress from 'vux/src/components/x-progress/index.vue'
import Msg from 'vux/src/components/msg/index.vue'
import Badge from 'vux/src/components/badge/index.vue'
import Checklist from 'vux/src/components/checklist/index.vue'
import Swipeout from 'vux/src/components/swipeout/swipeout.vue'
import SwipeoutItem from 'vux/src/components/swipeout/swipeout-item.vue'
import SwipeoutButton from 'vux/src/components/swipeout/swipeout-button.vue'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import LoadMore from 'vux/src/components/load-more/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Actionsheet from 'vux/src/components/actionsheet/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import ViewBox from 'vux/src/components/view-box/index.vue'
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XImg from 'vux/src/components/x-img/index.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'

import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import DatetimePlugin from 'vux/src/plugins/datetime/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'
import AlertPlugin from 'vux/src/plugins/alert/index.js'


import VueScroller from 'vue-scroller'
Vue.use(VueScroller)

Vue.use(ToastPlugin)
Vue.use(DatetimePlugin)
Vue.use(ConfirmPlugin)
Vue.use(AlertPlugin)
Vue.use(LoadingPlugin)

Vue.component('x-header', XHeader)
Vue.component('tabbar', Tabbar)
Vue.component('tabbar-item', TabbarItem)
Vue.component('tab', Tab)
Vue.component('tab-item', TabItem)
Vue.component('view-box', ViewBox)
Vue.component('grid-item', GridItem)
Vue.component('grid', Grid)
Vue.component('cell-box', CellBox)
Vue.component('cell', Cell)
Vue.component('x-img', XImg)
Vue.component('swiper', Swiper)
Vue.component('swiper-item', SwiperItem)
Vue.component('flexbox', Flexbox)
Vue.component('flexbox-item', FlexboxItem)
Vue.component('x-button', XButton)
Vue.component('actionsheet', Actionsheet)
Vue.component('load-more', LoadMore)
Vue.component('popup', Popup)
Vue.component('x-input', XInput)
Vue.component('x-textarea', XTextarea)
Vue.component('x-switch', XSwitch)
Vue.component('checker', Checker)
Vue.component('checker-item', CheckerItem)
Vue.component('swipeout', Swipeout)
Vue.component('swipeout-item', SwipeoutItem)
Vue.component('swipeout-button', SwipeoutButton)
Vue.component('checklist', Checklist)
Vue.component('badge', Badge)
Vue.component('msg', Msg)
Vue.component('x-progress', XProgress)
Vue.component('previewer', Previewer)
Vue.component('masker', Masker)
Vue.component('x-dialog', XDialog)
Vue.component('popover', Popover)




// WEBPACK FOOTER //
// ./src/config/vux.js